import { ref, computed } from 'vue'

export let loading = ref(false)

export const isMobile = computed(() => {
  if (window.innerWidth > 700) {
    return false
  }
  return true
})

export const baseH5Url = computed(() => {
  if (process.env.VUE_APP_env === 'dev' || process.env.VUE_APP_env === 'local') {
    return 'http://h5.mall.s.boom-cloud.com'
  } else if (process.env.VUE_APP_env === 'test') {
    return 'http://h5.mall.test.s.boomsj.com'
  } else if (process.env.VUE_APP_env === 'pre') {
    return 'https://h5.mall.tanchi0757.shop'
  } else {
    return 'https://h5.mall.tanchi.shop'
  }
})
